export default __webpack_public_path__ + "static/media/slider-img18.151f2e6d.jpg";